export default __webpack_public_path__ + "static/media/All-Purpose-Cleaners.3e28dcf5.jpg";